import { useContext, useMemo } from "react";
import { DOMAIN, PERMISSION, useCanManageCommitteesBool, useHasCapabilityBool } from "@/hooks/useCapabilities";
import { AuthorizationContext } from "@/providers/AuthorizationProvider";
import { canAccessGroupEmail } from "./groupEmailScopes";

export function useCanAccessGroupEmail(): boolean {
  const { loaded, sectionLegacyIds, sectionLegacyIdsLoading } = useContext(AuthorizationContext);
  const canManageCommittees = useCanManageCommitteesBool();
  const canViewPersonContact = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewPersonContact
  });

  return useMemo(
    () =>
      canAccessGroupEmail({
        canViewPersonContact,
        canManageCommittees,
        assignedSectionLegacyIds: sectionLegacyIds,
        loaded,
        sectionLegacyIdsLoading
      }),
    [canManageCommittees, canViewPersonContact, loaded, sectionLegacyIds, sectionLegacyIdsLoading]
  );
}
